import { IGetAllAssistenciaRegistroAtendimentoUseCase } from "../../../presentation/useCases/read/get_all_assistencia_registro_atendimento_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { AssistenciaTecnicaAtendimentoLista } from "../../models/assistencia_tecnica_atendimento_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllAssistenciaRegistroAtendimentoUseCase
 */

export class GetAllAssistenciaRegistroAtendimentoUseCase
  extends BasePaginatedUseCase<AssistenciaTecnicaAtendimentoLista>
  implements IGetAllAssistenciaRegistroAtendimentoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllAssistenciaRegistroAtendimento(
    idAssistenciaTecnica: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idAssistenciaTecnica === null) {
      throw new Error('ID da assistência técnica é obrigatório para buscar os registros de atendimento!');
    }

    const result = await this.repository.getAllAssistenciaRegistroAtendimento(
      idAssistenciaTecnica,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
